import { createSlice } from '@reduxjs/toolkit';
import { getEmployeeListThunk } from './Employee.thunk';

export const employeeSlice = createSlice({
  name: 'employee',
  initialState: {
    list: {
      items: [],
      loading: true,
      pagination: {},
    },
  },
  reducers: {},
  extraReducers: builder => {
    // Start Employee list
    builder.addCase(getEmployeeListThunk.pending, (state, action) => {
      state.list = { ...state.list, loading: true };
    });
    builder.addCase(getEmployeeListThunk.fulfilled, (state, action) => {
      const { data, pagination: _pagination } = action.payload;
      const pagination = _pagination
        ? {
            currentPage: _pagination.current_page,
            lastPage: _pagination.last_page,
            total: _pagination.total,
          }
        : {};
      state.list = { ...state.list, items: data, pagination, loading: false };
    });
    builder.addCase(getEmployeeListThunk.rejected, (state, action) => {
      // state.list = { ...state.list, loading: false };
    });
    // End Employee list
  },
});

export const getEmployeeList = (state: any) => state.employee.list;

export default employeeSlice.reducer;
